import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { PageHeader, EmptyState } from "@/components/ui-bits";
import { Card } from "@/components/ui/card";
import { Table, TableHeader, TableBody, TableHead, TableRow, TableCell } from "@/components/ui/table";
import { toast } from "sonner";

const Audit = () => {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const canView = ["super_admin", "director"].includes(user?.role);

  useEffect(() => {
    if (!canView) return;
    api.get("/audit-logs").then((r) => setList(r.data)).catch((e) => toast.error(formatApiError(e)));
  }, [canView]);

  if (!canView) return <div className="text-[#475569]">Only Super Admin and Director can view audit logs.</div>;

  return (
    <div data-testid="audit-page">
      <PageHeader overline="Security" title="Audit Logs" description="Every change captured — who, what and when." />
      {list.length === 0 ? <EmptyState message="No activity yet." /> : (
        <Card className="border-[#E2E8F0] overflow-hidden">
          <Table>
            <TableHeader><TableRow className="bg-[#FDFBF7]">
              <TableHead>When</TableHead><TableHead>Actor</TableHead><TableHead>Role</TableHead><TableHead>Action</TableHead>
              <TableHead>Entity</TableHead><TableHead>Entity ID</TableHead><TableHead>Meta</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {list.map(l => (
                <TableRow key={l.id} data-testid={`audit-${l.id}`}>
                  <TableCell className="text-xs">{new Date(l.at).toLocaleString()}</TableCell>
                  <TableCell className="font-medium text-[#1B2C5A]">{l.actor_email || "—"}</TableCell>
                  <TableCell className="text-xs">{l.actor_role}</TableCell>
                  <TableCell><span className="text-xs px-2 py-0.5 rounded-full bg-[#9DCD3F]/15 text-[#1B2C5A]">{l.action}</span></TableCell>
                  <TableCell>{l.entity}</TableCell>
                  <TableCell className="font-mono text-xs">{l.entity_id || "—"}</TableCell>
                  <TableCell className="text-xs text-[#475569]">{l.meta ? JSON.stringify(l.meta) : "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      )}
    </div>
  );
};

export default Audit;
